import { ColumnType } from "antd/lib/table";
import { Statuses } from "./Statuses";
import { Tooltip } from "antd"

function getColumns(
  periodoProducao?: string
): ColumnType<any>[] {
  return [
    {
      title: "Período de Produção",
      dataIndex: "periodoProducao",
      align: "center",
      width: 220,
      render: (_, record) => !!!record.isSubtotal && <span>{`${periodoProducao}`}</span>,
    },
    {
      title: "Operação",
      dataIndex: "operacao",
      align: "center",
      width: 200,
      render: (value: string) => <span>{value ?? ""}</span>,
    },
    {
      title: "Talhão",
      dataIndex: "talhao",
      align: "center",
      width: 70,
      render: (value: string) => <span>{value ?? ""}</span>,
    },
    {
    title: "Área",
    dataIndex: "areaHa",
    align: "center",
    width: 100,
    render: (value, record) => {
      if (record.isSubtotal) {
        return (
          <Statuses title={record.statusAtual} titleColor={false}>
            {value.toLocaleString('pt-BR')} ha
          </Statuses>
        );
      }

      return `${value.toLocaleString('pt-BR')} ha`;
    }
  },
    {
      title: "Situação OS",
      dataIndex: "ordemServicoSituacao",
      align: "center",
      width: 220,
      render: (value: string, record: any) => {
        let title = undefined; 
        if (record.ordensServico?.length > 0) {
          title = record.ordensServico.map((os: number) => <p>O.S. {os}</p>);
        }
        return (
          <Tooltip title={title}>{value ?? ""}</Tooltip>
        )
      },
    },
    {
      title: "Status",
      dataIndex: "statusAtual",
      align: "center",
      width: 150,
      render: (value: string, record: any) => !!!record.isSubtotal && <Statuses title={value}>{value ?? ""}</Statuses>,
    },
  ];
}

export default getColumns;
